var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{attrs:{"rowSize":"lg","columns":_vm.historyColumns,"rows":_vm.rows,"index":"","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }